import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { BrowserTracing, integrations } from "@sentry/tracing";

Sentry.init({
  dsn: "https://2eedcfadc43147acbf63035bcef30d20@o4504514375122944.ingest.sentry.io/4504515128328192",
  release: process.env.npm_package_version,
  environment: 'development',
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enebled: true,
  integrations: [new BrowserTracing({tracingOrigins: ["*"]}), new Sentry.Replay()],
  tracesSampleRate: 1.0,
  autoSessionTracking: true // Release Health
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
